export default __webpack_public_path__ + "static/media/petal-snapshot-lg.5ea3b092.gif";